module.exports = __webpack_public_path__ + "static/media/twitter-logo.5f97991a.svg";